/* eslint-disable react/prop-types */
import classes from "./card-view-list-step-two.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";

function CardViewListStepTwo({ step }) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.container}
    >
      {step?.icon && (
        <img src={step.icon} alt="Logo" className={classes.icon} />
      )}
      <Label weight="bold" tag="h5" color="secondary" align="start">
        {step?.title}
      </Label>
      <Label align="start" size="md" color="secondary">
        {step?.content}
      </Label>
    </Flex>
  );
}

export default CardViewListStepTwo;
